import { useEffect } from 'react';
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import { Route, Routes } from 'react-router-dom';

import Announcement from '../components/main/announcement';

import ActiveDevices from '../components/data/activedevices';
import Analytics from '../components/data/analytics';
import Dashboard from '../components/data/dashboard';
import HackingDetection from '../components/data/hackingdetection';

import Android from '../components/sealing/android';
import AppServiceiOS from '../components/sealing/ios';

import NewPassword from '../components/login/ResetPassword/index';
import ForgotPassword from '../components/login/forgotpassword';
import SignIn from '../components/login/signin';
import BillingDetails from '../components/manage/billingdetails';
import BillingInvoice from '../components/manage/billingdetails/invoice';
import BillingPlan from '../components/manage/billingdetails/plan';
import BillingTransaction from '../components/manage/billingdetails/transactionhistory';
import Account from '../components/manage/organization';
import ManageNotifications from '../components/manage/settings/managenotifications';
import ManageProduct from '../components/manage/settings/manageproduct';
import ManageService from '../components/manage/settings/manageservice';
import ConfigureService from '../components/manage/settings/manageservice/manage';
import ManageThreat from '../components/manage/settings/managethreat';
import CreateThreat from '../components/manage/settings/managethreat/createThreat';
import ManageWebhook from '../components/manage/settings/managewebhook';
import CreateWebhook from '../components/manage/settings/managewebhook/createWebhook';
import User from '../components/manage/user';
import { PlanExpired } from '../components/utils/common';

const TRACKING_ID = 'UA-62232685-1';
ReactGA.initialize(TRACKING_ID);

const NEW_TRACKING_ID = 'G-W6Y2779HVQ';
ReactGA4.initialize(NEW_TRACKING_ID);

const PublicRoutes = () => {
    useEffect(() => {
        if (window.location.host === 'console.appsealing.com') {
            ReactGA.pageview(window.location.hash);
            ReactGA4.send({ hitType: 'pageview', page: window.location.hash });
        }
    });

    return (
        <Routes>
            <Route path="/*" element={<SignIn />} />
            <Route path="/resetpassword" element={<NewPassword />} />
            <Route path="/updatepassword" element={<ForgotPassword />} />
        </Routes>
    );
};

const ProtectedRoutes = (props: { androidExpired: boolean; iOSExpired: boolean }) => {
    useEffect(() => {
        if (window.location.host === 'console.appsealing.com') {
            ReactGA.pageview(window.location.hash);
            ReactGA4.send({ hitType: 'pageview', page: window.location.hash });
        }
    });

    return (
        <Routes>
            <Route path="/dashboard" element={props.androidExpired && props.iOSExpired ? <PlanExpired /> : <Dashboard />} />
            <Route path="/analytics" element={props.androidExpired && props.iOSExpired ? <PlanExpired /> : <Analytics />} />
            <Route path="/activedevices" element={props.androidExpired && props.iOSExpired ? <PlanExpired /> : <ActiveDevices />} />
            <Route path="/threatdetection" element={props.androidExpired && props.iOSExpired ? <PlanExpired /> : <HackingDetection />} />
            <Route path="/threatdetection/:id" element={props.androidExpired && props.iOSExpired ? <PlanExpired /> : <HackingDetection />} />
            <Route path="/start-securing-your-app/:id" element={props.androidExpired && props.iOSExpired ? <PlanExpired /> : <Android />} />
            <Route path="/sealingandroid" element={props.androidExpired && props.iOSExpired ? <PlanExpired /> : <Android />} />
            <Route path="/sealingandroid/*" element={props.androidExpired && props.iOSExpired ? <PlanExpired /> : <Android />} />
            <Route path="/sealingios" element={props.androidExpired && props.iOSExpired ? <PlanExpired /> : <AppServiceiOS />} />
            <Route path="/sealingios/*" element={props.androidExpired && props.iOSExpired ? <PlanExpired /> : <AppServiceiOS />} />
            <Route path="/organization" element={<Account />} />
            <Route path="/organization/*" element={<Account />} />
            <Route path="/billingdetails" element={<BillingDetails />} />
            <Route path="/billingdetails/info" element={<BillingDetails />} />
            <Route path="/billingdetails/plan" element={<BillingPlan />} />
            <Route path="/billingdetails/invoice" element={<BillingInvoice />} />
            <Route path="/billingdetails/history" element={<BillingTransaction />} />
            <Route path="/settings/notifications" element={<ManageNotifications />} />
            <Route path="/settings/service" element={<ManageService />} />
            <Route path="/settings/products" element={<ManageProduct />} />
            <Route path="/settings/threat" element={<ManageThreat />} />
            <Route path="/settings/threat/create/:id?" element={<CreateThreat />} />
            <Route path="/settings/webhook" element={<ManageWebhook />} />
            <Route path="/settings/webhook/create/:id?" element={<CreateWebhook />} />
            <Route path="/settings/service/configure/:id" element={<ConfigureService />} />
            <Route path="/announcement" element={<Announcement />} />
            <Route path="/announcement/:seq" element={<Announcement />} />
            <Route path="/profile" element={<User />} />
            <Route path="/*" element={<Dashboard />} />
        </Routes>
    );
};

export { ProtectedRoutes, PublicRoutes };
